<div [ngClass]="{ 'topheader': twofiftylogo == false, 'twofiftytopheader': twofiftylogo == true }">
    <div class="row ">

        <div class="col-2  d-flex justify-content-center" [ngClass]="{ 'leftnav': twofiftylogo == false, 'twofiftyleftnav': twofiftylogo == true }">
            <!-- <a [routerLink]="[navigation.getPreviousUrl()]"><i class="fa-solid fa-left-long"></i></a> -->
            <span (click)="navigation.goBack()"><i class="fa-solid fa-left-long"></i></span>
            <!-- <a [routerLink]="[navigation.getPreviousUrl()]"><fa-icon [icon]="['fas','left-long']"></fa-icon></a> -->
        </div>
        <div class="logo col-8  d-flex justify-content-center">
            <img class="logotop" *ngIf="twofiftylogo == false" src="{{imagepath}}ACL_Flag.png">
            <img class="twofiftylogotop" *ngIf="twofiftylogo == true" src="https://www.americancruiselines.com/getmedia/334ebdbe-4d44-41b8-9b6c-16d7c88a0a72/ACL_250_LOGO1_KO.png">
        </div>
        <div class="alertbell col-2  d-flex justify-content-center">
            <!-- <i class="fa-solid fa-bell"></i> -->
        </div>
    </div>
</div>